import DataTable from "react-data-table-component";
import classes from "./Metrics.module.css";
import { useState, useEffect } from "react";
import { useAuth } from "react-oidc-context";

const columns = [
  {
    name: "Metric Name",
    selector: (row) => row.name,
  },
  {
    name: "Type",
    selector: (row) => row.type,
  },
  {
    name: "Description",
    selector: (row) => row.description,
  },
];


export default function MetricsTable() {
  const [availableMetrics, setAvailableMetrics] = useState([]);
  const auth = useAuth();
  console.log(`${auth.user?.access_token}`)

  useEffect(() => {
    async function fetchMetrics() {
        const response = await fetch("/api/metrics/", {
          method: "GET",
          headers: {
            Authorization: `Bearer ${auth.user?.access_token}`,
            "Content-Type": "application/json",
          },
        });
      const resData = await response.json();
      setAvailableMetrics(resData);
    }
    fetchMetrics();
  }, []);

  return (
    <DataTable
      columns={columns}
      data={availableMetrics}
      className={classes.table}
    />
  );
}
